import React from 'react';

const ArrowLeft = (props) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M22.5 10.5H5.3l9.2-8c.3-.3.4-.6.5-1 0-.4-.1-.8-.4-1.1-.3-.3-.7-.4-1.1-.4-.3 0-.6.1-.8.2L.7 10.8c-.1.1-.2.2-.2.3l-.1.1c-.1.2-.2.4-.2.7 0 .2 0 .4.1.6 0 .1.1.2.2.3.1.1.2.2.3.2l11.9 10.4c.2.2.6.4.9.4.4 0 .8-.2 1.1-.5.5-.5.5-1.4-.1-2l-9.1-8h17.2c.8 0 1.4-.6 1.4-1.4-.1-.8-.8-1.4-1.6-1.4z" />
  </svg>
);

export default ArrowLeft;
